import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'smartReport',
    label: 'SMART Goals Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
